import { Box } from '@mui/material'
import editIcon from '../../assests/DT-action-icon/edit-03.svg'
import deleteIcon from '../../assests/DT-action-icon/delete-01.svg'

interface ActionIconProps {
  size?: number
}

export function EditActionIcon({ size = 14 }: ActionIconProps) {
  return (
    <Box
      component="img"
      src={editIcon}
      alt="edit"
      sx={{ width: size, height: size, display: 'block' }}
    />
  )
}

export function DeleteActionIcon({ size = 14 }: ActionIconProps) {
  return (
    <Box
      component="img"
      src={deleteIcon}
      alt="delete"
      sx={{ width: size, height: size, display: 'block' }}
    />
  )
}
